<template>
    <div class="page">
        <div class="second-header-wrap">
            <el-select v-model="currentNotice" @change="noticeChange" placeholder="请选择">
                <el-option
                    v-for="noticeItem in noticeList"
                    :key="noticeItem.id"
                    :label="noticeItem.title"
                    :value="noticeItem.id">
                </el-option>
            </el-select>
        </div>
        <div class="accounting first-accounting">
            <div class="header">
                <span class="color-block"></span>
                线上一审统计
            </div>
            <div class="data-chart" id="first-online-chart">
            </div>
        </div>
        <div class="accounting second-accounting">
            <div class="header">
                <span class="color-block"></span>
                线上二审统计
            </div>
            <div class="data-chart" id="second-online-chart">
            </div>
        </div>

        <div class="accounting first-accounting">
            <div class="header">
                <span class="color-block"></span>
                线下一审统计
            </div>
            <div class="data-chart" id="first-chart">
            </div>
        </div>
        <div class="accounting second-accounting">
            <div class="header">
                <span class="color-block"></span>
                线下二审统计
            </div>
            <div class="data-chart" id="second-chart">
            </div>
        </div>
        <div class="accounting ticket-accounting">
            <div class="header">
                <span class="color-block"></span>
                各窗口线下一审进度统计
            </div>
            <div v-show="ticketData && ticketData.length !== 0" class="data-chart" id="ticket-chart">
            </div>
            <default-page v-show="ticketData && ticketData.length === 0"></default-page>
        </div>
    </div>
</template>

<script>
    import DefaultPage from '@/components/DefaultPage';
    import moment from 'moment';
    import echarts from 'echarts';

    import {
        getSchoolEnrolNoticeList,
        getEnrolOfflineOneAnalysisData,
        getEnrolOfflineTwoAnalysisData,
        getWindowUserCountAnalysisDatas,

        getEnrolOnlineOneAnalysisDataList,
        getEnrolOnlineTwoAnalysisDataList,
        getOfflineOneWindowUserCountDataList

    } from '@/api/primary/accounting';

    function drawBarChart(containerId, config) {
        if (!config.tooltip) {
            config.tooltip = {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            };
        }

        const option = {
            color: [
                "#3fb1e3",
                "#6be6c1",
                "#626c91",
                "#a0a7e6",
                "#c4ebad",
                "#96dee8"
            ],
            dataZoom: {
                zoomLock: true,
                show: config.isNoZoom ? false : config.xAxisData.length > 10,
                realtime: true,
                start: 0,
                end: config.isNoZoom ? 100 : 100 / config.xAxisData.length * 10 > 100 ? 100 : 100 / config.xAxisData.length * 10,
                showDetail: false
            },
            tooltip: config.tooltip,
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    axisLabel: {
                        interval: 0,
                    },
                    type: 'category',
                    data: config.xAxisData,
                }
            ],
            yAxis: [
                {
                    name: config.yAxisName,
                    type: 'value',
                    minInterval: 1
                }
            ],
            series: config.series,
        };

        if (document.getElementById(containerId) !== null) {
            echarts.init(document.getElementById(containerId)).setOption(option);
        }
    }

    export default {
        name: "reviewAccounting",
        data() {
            return {
                currentNotice: 0,
                noticeList: [],
                firstReview: [],
                secondReview: [],
                ticketData: [],
                onlineOneData: [],
                onlineTwoData: []
            }
        },
        components: {DefaultPage},
        mounted() {
            getSchoolEnrolNoticeList({
                searchVal: '',
                state: 2
            })
                .then(res => res.data)
                .then(data => {
                    this.noticeList = data.data;
                    if (data.data.length !== 0) {
                        this.currentNotice = data.data[0].id;
                        this.getEnrolOfflineOneAnalysisDataFunc();
                        this.getEnrolOfflineTwoAnalysisDataFunc();
                        this.getOfflineOneWindowUserCountDataListFunc();
                        this.getEnrolOnlineOneAnalysisDataListFunc();
                        this.getEnrolOnlineTwoAnalysisDataListFunc();
                    }
                });
        },
        methods: {
            noticeChange() {
                this.getEnrolOfflineOneAnalysisDataFunc();
                this.getEnrolOfflineTwoAnalysisDataFunc();
                this.getOfflineOneWindowUserCountDataListFunc();
                this.getEnrolOnlineOneAnalysisDataListFunc();
                this.getEnrolOnlineTwoAnalysisDataListFunc();
            },
            getEnrolOnlineOneAnalysisDataListFunc() {
                getEnrolOnlineOneAnalysisDataList({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        const xAxisData = [];
                        const series = [{
                            name: '已审核',
                            type: 'bar',
                            barWidth: '50%',
                            stack: '人数',
                            data: [],
                            label: {
                                normal: {
                                    position: 'top'
                                }
                            },
                        }, {
                            name: '未审核',
                            type: 'bar',
                            barWidth: '50%',
                            stack: '人数',
                            data: [],
                            label: {
                                normal: {
                                    position: 'top'
                                }
                            },
                        }];
                        data.data.forEach(item => {
                            xAxisData.push(item.groupName);
                            series[0].data.push(item.finishOneCount);
                            series[1].data.push(item.unfinishOneCount);
                        });
                        this.onlineOneData = data.data;
                        drawBarChart('first-online-chart', {
                            yAxisName: '人数',
                            xAxisData,
                            series,
                            tooltip: {
                                trigger: 'item',
                                formatter: (item) => {
                                    return `总人数：${this.onlineOneData[item.dataIndex].enrolCount}人<br />
                                    已审核：${this.onlineOneData[item.dataIndex].finishOneCount}人<br />
                                    未审核：${this.onlineOneData[item.dataIndex].unfinishOneCount}人`
                                }
                            },
                        });
                    })
            },
            getEnrolOnlineTwoAnalysisDataListFunc() {
                getEnrolOnlineTwoAnalysisDataList({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        const xAxisData = [];
                        const series = [{
                            name: '已审核',
                            type: 'bar',
                            barWidth: '50%',
                            stack: '人数',
                            data: [],
                            label: {
                                normal: {
                                    show: true,
                                }
                            },
                        }, {
                            name: '未审核',
                            type: 'bar',
                            barWidth: '50%',
                            stack: '人数',
                            data: [],
                            label: {
                                normal: {
                                    show: true,
                                }
                            },
                        }];
                        data.data.forEach(item => {
                            xAxisData.push(item.groupName);
                            series[0].data.push(item.finishTwoCount);
                            series[1].data.push(item.unfinishTwoCount);
                        });
                        this.onlineTwoData = data.data;
                        drawBarChart('second-online-chart', {
                            yAxisName: '人数',
                            xAxisData,
                            series,
                            tooltip: {
                                trigger: 'item',
                                formatter: (item) => {
                                    return `总人数：${this.onlineTwoData[item.dataIndex].enrolCount}人<br />
                                    已审核：${this.onlineTwoData[item.dataIndex].finishTwoCount}人<br />
                                    未审核：${this.onlineTwoData[item.dataIndex].unfinishTwoCount}人`
                                }
                            },
                        });
                    })
            },
            // 一审统计
            getEnrolOfflineOneAnalysisDataFunc() {
                getEnrolOfflineOneAnalysisData({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        const pageData = data.data;
                        this.firstReview = pageData;
                        drawBarChart('first-chart', {
                            yAxisName: '人数',
                            xAxisData: ['不通过', '待确认', '通过', '未完成', '完成'],
                            series: [
                                {
                                    name: '人数',
                                    type: 'bar',
                                    barWidth: '50%',
                                    data: [
                                        pageData.btgOfflineOneCount,
                                        pageData.dqrOfflineOneCount,
                                        pageData.tgOfflineOneCount,
                                        pageData.unfinishOneCount,
                                        pageData.finishOneCount,
                                    ],
                                    label: {
                                        normal: {
                                            show: true,
                                        }
                                    },
                                }
                            ]
                        });
                    })
            },
            // 二审统计
            getEnrolOfflineTwoAnalysisDataFunc() {
                getEnrolOfflineTwoAnalysisData({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        const pageData = data.data;
                        this.secondReview = pageData;
                        drawBarChart('second-chart', {
                            yAxisName: '人数',
                            xAxisData: ['不通过', '待确认', '通过', '未完成', '完成'],
                            series: [
                                {
                                    name: '人数',
                                    type: 'bar',
                                    barWidth: '50%',
                                    data: [
                                        pageData.btgOfflineTwoCount,
                                        pageData.dqrOfflineTwoCount,
                                        pageData.tgOfflineTwoCount,
                                        pageData.unfinishTwoCount,
                                        pageData.finishTwoCount,
                                    ],
                                    label: {
                                        normal: {
                                            show: true,
                                        }
                                    },
                                }
                            ]
                        });
                    })
            },
            getOfflineOneWindowUserCountDataListFunc() {
                getOfflineOneWindowUserCountDataList({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        console.log(data)
                        const xAxisData = [];
                        const series = [{
                            name: '已审核',
                            type: 'bar',
                            barWidth: '50%',
                            stack: '人数',
                            data: [],
                            label: {
                                normal: {
                                    show: true,
                                }
                            },
                        }, {
                            name: '未审核',
                            type: 'bar',
                            barWidth: '50%',
                            stack: '人数',
                            data: [],
                            label: {
                                normal: {
                                    show: true,
                                }
                            },
                        }];
                        data.data.forEach(item => {
                            xAxisData.push(item.windowNo);
                            series[0].data.push(item.finishCount);
                            series[1].data.push(item.unfinishCount);
                        });
                        this.ticketData = data.data;
                        drawBarChart('ticket-chart', {
                            yAxisName: '人数',
                            xAxisData,
                            series,
                            tooltip: {
                                trigger: 'item',
                                formatter: (item) => {
                                    return `总人数：${this.ticketData[item.dataIndex].userNo}人<br />
                                    已审核：${this.ticketData[item.dataIndex].finishCount}人<br />
                                    未审核：${this.ticketData[item.dataIndex].unfinishCount}人`
                                }
                            },
                        });
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    @include globalstyle;

    .page {
        padding: 15px;
    }

    .header {
        font-size: 18px;
        border-bottom: 1px solid #20a0ff;
        width: 250px;

        .color-block {
            @include wh(20px, 20px);
            @include middleIB;
            background-color: #20a0ff;
            margin-right: 5px;
        }

        white-space: nowrap;
        margin: 10px 5px 10px 0;
        padding: 0 0 10px 0;
    }

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1000px;
        height: 60px;
        line-height: 60px;
        padding: 5px 0;
        background-color: #fff;
        z-index: 1000;
    }

    .data-container {
        width: 400px;
        box-sizing: border-box;
        border: 1px solid #409EFF;
        border-radius: 10px;
        padding: 20px;
        font-size: 18px;

        span {
            @include middleIB;

        }

        .data-item__desc {
            width: 70%;
        }

        .data-item__data {
            width: 28%;
        }
    }

    .first-accounting, .second-accounting, .ticket-accounting {
        float: left;
        width: 720px;
        margin-right: 10px;

        .data-chart {
            float: left;
            width: 700px;
            height: 400px;

        }

        .data-container {
            width: 220px;
            float: left;
        }

        .data-item__desc {
            width: 68%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/accounting/ReviewAccounting.vue